import type { TourAnalyticsContext, TourEventProps } from './types';

/** Build the launcher-screen event props (fired when the launcher card itself
 *  is shown / its CTAs are clicked). `tutorial_step_number` is always
 *  "Launcher" for these. */
export const launcherEventProps = (ctx: TourAnalyticsContext) => ({
  platform_page: ctx.platform_page,
  feature_name: ctx.feature_name,
  tutorial_step_number: 'Launcher',
  tutorial_screen_header_text: ctx.launcherHeaderText,
});

/** Build the eventProps to pass into `useOnboardingTour` for the tour-runner
 *  step events. Extra per-tour context (e.g. fastpass counts) rides along. */
export const tourStepEventProps = (
  ctx: TourAnalyticsContext,
  extras?: Record<string, string | number | null>
): TourEventProps => ({
  platform_page: ctx.platform_page,
  feature_name: ctx.feature_name,
  ...extras,
});
